import { equal } from '@wry/equality';
import { requireReactLazily } from '../../react';
export function useDeepMemo(memoFn, key) {
    var React = requireReactLazily();
    var useRef = React.useRef;
    var ref = useRef();
    if (!ref.current || !equal(key, ref.current.key)) {
        ref.current = { key: key, value: memoFn() };
    }
    return ref.current.value;
}
//# sourceMappingURL=useDeepMemo.js.map